import "../RolePermissions/RolePermissions.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Grid2, InputBase, Paper } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  fetchAllReportsDataService,
  updateRoleReportsService,
} from "../../../services/roleManagementService";
import { notifyError } from "../../../utilities/helper";
import Loader from "../../../components/Loader";
import CustomAPISwitch from "../../../components/CustomSwitch/CustomAPISwitch";
import { SearchSharp } from "@mui/icons-material";

const RoleReports = () => {
  const [load, setLoad] = useState(false);
  const [reportsData, setReportsData] = useState(null);
  const [scrollToKey, setScrollToKey] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const reportsRef = useRef({});

  const access_token = localStorage.getItem("access_token");

  const location = useLocation();
  const navigate = useNavigate();

  const roleId = location.state.id;

  useEffect(() => {
    if (roleId) {
      fetchReportsData(roleId);
    }
  }, [roleId]);

  // This is for scrolling to that section of the page whose data is updated
  useEffect(() => {
    if (scrollToKey && reportsRef.current[scrollToKey]) {
      reportsRef.current[scrollToKey]?.scrollIntoView({
        behavior: "smooth",
      });
      setScrollToKey(null);
    }
  }, [reportsData]); // trigger scroll after new data is rendered

  const filterReportData = useMemo(() => {
    const lowerSearch = (searchTerm || "").toString().toLowerCase();

    if (!lowerSearch) return reportsData;

    let result = [];

    const matchedReportData = reportsData?.filter((report) =>
      report?.reportName?.toLowerCase().includes(lowerSearch)
    );

    if (matchedReportData.length > 0) {
      result = matchedReportData;
    }

    return result;
  }, [reportsData, searchTerm]);

  const fetchReportsData = async (id) => {
    let res = null;
    setLoad(true);
    try {
      res = await fetchAllReportsDataService(id, access_token);
      if (res?.status === 200) {
        setReportsData(res?.data?.result?.reportData);
        setLoad(false);
      } else {
        notifyError("Failed to fetch report data");
        setLoad(false);
      }
    } catch (err) {
      console.log(err);
      setLoad(false);
      notifyError("Failed to fetch report data");
      if (err.status === 401) {
        navigate("/unauthorize");
      }
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p
            className="bread-crumbs-link-container"
            style={{ fontWeight: "600" }}
          >
            <Link className="bread-crumbs-link" to="/">
              Home
            </Link>{" "}
            |{" "}
            <Link className="bread-crumbs-link" to="/role-management">
              Role Management
            </Link>{" "}
            |{" "}
            <Link
              className="bread-crumbs-link"
              to="/role-reports"
              state={{ id: roleId }}
            >
              Manage Role Report
            </Link>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>

          <Grid2
            container
            alignItems="start"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={12} sx={{ marginTop: "1%", marginBottom: "1%" }}>
              <Paper className="search-bar-conatiner">
                <SearchSharp style={{ width: 20, height: 20 }} />
                <InputBase
                  sx={{ ml: 1, flex: 1, fontSize: 16 }}
                  value={searchTerm}
                  placeholder={`Search Reports`}
                  inputProps={{ "aria-label": `search reports` }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Paper>
            </Grid2>
          </Grid2>

          <div className="permission-container" style={{ marginTop: "2%" }}>
            {filterReportData && filterReportData?.length > 0 ? (
              <>
                <div className="permission-heading-container">
                  <span className="permission-heading">Genesis</span>
                </div>
                {filterReportData &&
                  filterReportData?.map((report, index) => (
                    <Grid2
                      key={index}
                      container
                      ref={(el) => (reportsRef.current[report.id] = el)}
                      justifyContent="space-between"
                      alignItems={"center"}
                      sx={{
                        width: "100%",
                        padding: "10px",
                        borderBottom: "1px solid #ccc",
                        ":hover": { backgroundColor: "#f5f5f5" },
                      }}
                    >
                      <Grid2 size={{ lg: 11, md: 11, xl: 11, sm: 11 }}>
                        <span>{report?.reportName}</span>
                      </Grid2>
                      <Grid2 size={{ lg: 1, md: 1, xl: 1, sm: 1 }}>
                        <CustomAPISwitch
                          isSwitch={report?.associatedToUser}
                          api={updateRoleReportsService}
                          data={{
                            roleId: roleId,
                            reportId: report?.id,
                            add: !report?.associatedToUser,
                          }}
                          onScrollKey={() => setScrollToKey(report.id)}
                          fetchOriginalData={fetchReportsData}
                          roleId={roleId}
                        />
                      </Grid2>
                    </Grid2>
                  ))}
              </>
            ) : (
              <div className="search-fallback-container">
                <span>No Reports Found</span>
              </div>
            )}
          </div>

          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            sx={{ marginTop: "2%" }}
          >
            <Grid2 item md={6}>
              <button
                className="create-btn"
                onClick={() => {
                  navigate("/role-management");
                }}
              >
                Back
              </button>
            </Grid2>
          </Grid2>
        </div>
      )}
    </>
  );
};

export default RoleReports;
